module.exports = __webpack_public_path__ + "static/img/Jack-Lukosius.5a0eed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Lukosius.jpg
// module id = CAeB
// module chunks = 0